// Generated by Melange

import * as Buhta_cabinet__Search from "../../molecules/Search/Search.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function HrmEmployeeSalary(Props) {
  let status = Props.status;
  const match = React.useState(function () {
        return 1;
      });
  let tmp;
  switch (status) {
    case /* EMPLOYMENT_STATUS_ACTIVE */1 :
        tmp = JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: "text-default-gray",
                                          children: "Баланс"
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.H2.make, {
                                          className: "mt-1",
                                          children: "144 391 ₸"
                                        })
                                  ],
                                  className: "ml-0 md:ml-4"
                                }),
                            className: "flex"
                          }),
                      JsxRuntime.jsxs("button", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "text-gray-medium",
                                    children: "Приостановить"
                                  }),
                              JsxRuntime.jsx("img", {
                                    src: StaticAsset.src("/static/icons/pause.svg")
                                  })
                            ],
                            className: "flex items-center gap-1 border border-gray-main rounded-md px-3 py-2"
                          })
                    ],
                    className: " flex justify-between items-center"
                  }),
              className: "w-full border border-gray-main rounded-xl p-4 md:p-6"
            });
        break;
    case /* EMPLOYMENT_STATUS_UNSPECIFIED */0 :
    case /* EMPLOYMENT_STATUS_TERMINATED */2 :
        tmp = JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("img", {
                                        alt: "hrm-salary",
                                        src: StaticAsset.src("/static/icons/hrm-salary.svg")
                                      }),
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        className: "text-asphalt",
                                        children: "Сотрудник еще не подключен к сервису Зарплаты"
                                      })
                                ],
                                className: "flex items-center gap-6"
                              }),
                          className: " flex justify-between items-center"
                        }),
                    className: "w-full border border-gray-main rounded-xl p-4 md:p-6"
                  })
            });
        break;
    
  }
  return JsxRuntime.jsxs("div", {
              children: [
                tmp,
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                              className: "mb-4 md:!mb-0",
                              children: "Последние платежи"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("button", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                              children: "Пополнить"
                                            }),
                                        JsxRuntime.jsx("img", {
                                              alt: "buhta-plus",
                                              height: "16px",
                                              src: StaticAsset.src("/static/icons/plus-gray-20.svg"),
                                              width: "16px"
                                            })
                                      ],
                                      className: "flex items-center justify-center gap-1 border border-gray-main rounded w-full md:w-31 py-2 block"
                                    }),
                                JsxRuntime.jsxs("button", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                              children: "Списать"
                                            }),
                                        JsxRuntime.jsx("img", {
                                              alt: "buhta-plus",
                                              height: "16px",
                                              src: StaticAsset.src("/static/icons/minus-gray-16.svg"),
                                              width: "16px"
                                            })
                                      ],
                                      className: "flex items-center justify-center gap-1 border border-gray-main rounded w-full md:w-31 py-2 block mt-2"
                                    })
                              ],
                              className: "flex gap-4 items-baseline"
                            })
                      ],
                      className: "flex flex-col md:flex-row justify-between mt-6 md:mt-8"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_cabinet__Search.make, {
                            dispatch: (function (tenant, params, param) {
                                
                              }),
                            page: 1,
                            setPage: match[1],
                            searchLength: 1,
                            showFilter: true,
                            className: "!h-10 shadow-none !m-0"
                          }),
                      className: "border border-gray-main rounded-md mt-4 "
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "p-4 !pb-0 md:hidden",
                              children: "Выплата #23438312"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "hidden md:block",
                                              children: "Выплата #23438312"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      className: "text-gray-medium",
                                                      children: "15.09.2019 17:22:20"
                                                    }),
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("img", {
                                                              className: "w-5",
                                                              src: StaticAsset.src("/static/icons/time.svg")
                                                            }),
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              className: "ml-2 text-links",
                                                              children: "Отправлен"
                                                            })
                                                      ],
                                                      className: "flex items-center"
                                                    })
                                              ],
                                              className: "flex flex-col-reverse md:flex-row gap-2"
                                            })
                                      ],
                                      className: "flex flex-col gap-1"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "text-gray-medium font-semibold",
                                              children: "20 887,16 ₸"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "text-gray-medium",
                                                            children: "•••• 1380"
                                                          }),
                                                      JsxRuntime.jsx("img", {
                                                            className: "w-5 ml-2",
                                                            src: StaticAsset.src("/static/icons/visa-blue.svg")
                                                          })
                                                    ],
                                                    className: "flex items-center"
                                                  })
                                            })
                                      ],
                                      className: "flex flex-col gap-1"
                                    })
                              ],
                              className: "flex flex-row-reverse md:flex-row items-end md:items-center justify-between p-4 !pt-0 md:!pt-4 hover:bg-gray-pale"
                            }),
                        JsxRuntime.jsx("hr", {}),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "p-4 !pb-0 md:hidden",
                              children: "Выплата #23438312"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "hidden md:block",
                                              children: "Выплата #23438312"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      className: "text-gray-medium",
                                                      children: "15.09.2019 17:22:20"
                                                    }),
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("img", {
                                                              className: "w-5",
                                                              src: StaticAsset.src("/static/icons/time.svg")
                                                            }),
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              className: "ml-2 text-links",
                                                              children: "В процессе"
                                                            })
                                                      ],
                                                      className: "flex items-center"
                                                    })
                                              ],
                                              className: "flex flex-col-reverse md:flex-row gap-2"
                                            })
                                      ],
                                      className: "flex flex-col gap-1"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "text-gray-medium font-semibold",
                                              children: "20 887,16 ₸"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "text-gray-medium",
                                                            children: "•••• 8421"
                                                          }),
                                                      JsxRuntime.jsx("img", {
                                                            className: "w-5 ml-2",
                                                            src: StaticAsset.src("/static/icons/visa-blue.svg")
                                                          })
                                                    ],
                                                    className: "flex items-center"
                                                  })
                                            })
                                      ],
                                      className: "flex flex-col gap-1"
                                    })
                              ],
                              className: "flex flex-row-reverse md:flex-row items-end md:items-center justify-between p-4 !pt-0 md:!pt-4 hover:bg-gray-pale"
                            }),
                        JsxRuntime.jsx("hr", {}),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              children: "Начисление #582313491246272512"
                                            }),
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "text-gray-medium",
                                              children: "15.09.2019 17:22:20"
                                            })
                                      ],
                                      className: "flex flex-col gap-1"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "font-semibold text-success",
                                            children: "320 500 ₸"
                                          }),
                                      className: "flex flex-col gap-1"
                                    })
                              ],
                              className: "flex items-end md:items-center justify-between p-4 hover:bg-gray-pale"
                            }),
                        JsxRuntime.jsx("hr", {}),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "p-4 !pb-0 md:hidden",
                              children: "Выплата #23438312"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "hidden md:block",
                                              children: "Выплата #23438312"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      className: "text-gray-medium",
                                                      children: "15.09.2019 17:22:20"
                                                    }),
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("img", {
                                                              className: "w-5",
                                                              src: StaticAsset.src("/static/icons/error.svg")
                                                            }),
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              className: "ml-2 text-alert",
                                                              children: "Ошибка"
                                                            })
                                                      ],
                                                      className: "flex items-center"
                                                    })
                                              ],
                                              className: "flex flex-col-reverse md:flex-row gap-2"
                                            })
                                      ],
                                      className: "flex flex-col gap-1"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "text-alert font-semibold",
                                              children: "20 887,16 ₸"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "text-gray-medium",
                                                            children: "•••• 8421"
                                                          }),
                                                      JsxRuntime.jsx("img", {
                                                            className: "w-5 ml-2",
                                                            src: StaticAsset.src("/static/icons/mastercard-color.svg")
                                                          })
                                                    ],
                                                    className: "flex items-center"
                                                  })
                                            })
                                      ],
                                      className: "flex flex-col gap-1"
                                    })
                              ],
                              className: "flex flex-row-reverse md:flex-row items-end md:items-center justify-between p-4 !pt-0 md:!pt-4 hover:bg-gray-pale"
                            }),
                        JsxRuntime.jsx("hr", {}),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "p-4 !pb-0 md:hidden",
                              children: "Выплата #23438312"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "hidden md:block",
                                              children: "Выплата #23438312"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      className: "text-gray-medium",
                                                      children: "15.09.2019 17:22:20"
                                                    }),
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("img", {
                                                              className: "w-5",
                                                              src: StaticAsset.src("/static/icons/close-circle.svg")
                                                            }),
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              className: "text-gray-medium ml-2",
                                                              children: "Отменен"
                                                            })
                                                      ],
                                                      className: "flex items-center"
                                                    })
                                              ],
                                              className: "flex flex-col-reverse md:flex-row gap-2"
                                            })
                                      ],
                                      className: "flex flex-col gap-1"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "font-semibold tex-right",
                                              children: "20 887,16 ₸"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "text-gray-medium",
                                                            children: "•••• 8421"
                                                          }),
                                                      JsxRuntime.jsx("img", {
                                                            className: "w-5 ml-2",
                                                            src: StaticAsset.src("/static/icons/mastercard-color.svg")
                                                          })
                                                    ],
                                                    className: "flex items-center"
                                                  })
                                            })
                                      ],
                                      className: "flex flex-col gap-1"
                                    })
                              ],
                              className: "flex flex-row-reverse md:flex-row items-end md:items-center justify-between p-4 !pt-0 md:!pt-4 hover:bg-gray-pale"
                            })
                      ],
                      className: "border border-gray-main rounded-md mt-4"
                    })
              ],
              className: "min-w-[343px] md:w-[758px] mt-6 hidden"
            });
}

const make = HrmEmployeeSalary;

export {
  make ,
}
/* Buhta_cabinet__Search Not a pure module */
